import React, { useRef } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import withRootContext from 'context/withRootContextHOC'
import useLogin from 'src/components/loginForm/hooks/useLogin'
import Input from 'src/components/forms/input'
import Button from 'src/components/button'
import MODAL from 'src/utils/modals'
import * as S from './styles'

const LoginForm = ({
  onCancel,
  cancelLabel,
  confirmLabel,
  dataTest,
  successCallback,
  failureCallback,
  context: { toggleModalSheet }
}) => {
  const {
    form: { errors, register, submitForm, watch },
    siteRecaptchaKey,
    errorLogin
  } = useLogin()

  const recaptchaRef = useRef()

  const handleSubmit = async (event) => {
    event.preventDefault()
    await submitForm({ successCallback, failureCallback, recaptchaRef })
  }

  const handleForgotPassword = () => {
    return toggleModalSheet(MODAL.FORGOT_PASSWORD_MODAL({
      onCancel: toggleModalSheet,
      callback: toggleModalSheet
    }))
  }

  return (
    <>
      <S.Form onSubmit={(e) => handleSubmit(e)}>
        <S.FormFields>
          <Input
            dataTest='input-email-login-enter'
            name='email'
            id='login-email'
            type='email'
            label='Email'
            value={watch.email}
            placeholder='Utilize seu email do site Cobasi'
            margin='8px auto 0 auto'
            hookForm={register('email', { required: true })}
            errorMessage={errorLogin ?? errors.email?.message}
          />
          <Input
            eye
            dataTest='input-password-login-enter'
            id='login-password'
            name='password'
            type='password'
            label='Senha'
            value={watch.password}
            placeholder='Digite sua senha'
            margin='8px auto 0 auto'
            hookForm={register('password', { required: true })}
            errorMessage={errorLogin ?? errors.password?.message}
          />
        </S.FormFields>
        <ReCAPTCHA ref={recaptchaRef} size='invisible' sitekey={siteRecaptchaKey} />
        <S.BlockLink onClick={() => handleForgotPassword()}>Esqueci minha senha</S.BlockLink>
        <S.Footer>
          {confirmLabel && <Button margin='0' theme='primary' data-test={`${dataTest}-button-confirm`} type='submit'>{confirmLabel}</Button>}
          {cancelLabel && <Button margin='0' theme='borderless' data-test={`${dataTest}-button-cancel`} onClick={() => onCancel()}>{cancelLabel}</Button>}
        </S.Footer>
      </S.Form>
      <hr />
      <S.Info>Novo na Pet Anjo? <S.Link onClick={() => toggleModalSheet(MODAL.CREATE_ACCOUNT({ onCancel: () => toggleModalSheet(), callback: () => successCallback() }))}>Crie sua conta.</S.Link></S.Info>
    </>
  )
}

export default withRootContext(LoginForm)
